<div [formGroup]="form">
  <div class="flex flex-col w-full gap-2 mb-3">
    <label class="font-bold text-sm text-primary-400 mt-3">
      {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG_BUCHEN.TITEL_LIEFERSCHEINDATUM' | translate}}
    </label>
    <soft-date-input
      formControlName="bezugsdatum"
      changeTrigger="blur"
      (valueChange)="updateBelegdatumLocal($safeNavigationMigration(form?.value?.bezugsdatum))">
    </soft-date-input>
    @if (!form.controls['bezugsdatum'].valid) {
      <div
        class="text-red-800 font-semibold">
        {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG_BUCHEN.LABEL_GUELTIGES_LIEFERSCHEINDATUM_ANGEBEN' | translate}}
      </div>
    }
  </div>

  <div class="flex flex-col w-full gap-2 mb-3">
    <label class="font-bold text-sm text-primary-400 mt-3">
      {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG_BUCHEN.TITEL_LIEFERSCHEINNUMMER' | translate}}
    </label>
    <soft-input
      placeholder="Lieferscheinnummer"
      formControlName="lieferscheinnummer"
      (valueChange)="updateLieferscheinnummerLocal($safeNavigationMigration(form?.value?.lieferscheinnummer))">
    </soft-input>
    @if ((_eingabeLieferscheinnummerPflicht && !lieferscheinnummerValid$.value)
      || (form.controls['lieferscheinnummer'].value.toString()).length > 0 && !lieferscheinnummerValid$.value) {
      <div
        class="text-red-800 font-semibold">
        {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG_BUCHEN.LABEL_GUELTIGE_LFNUMMER_ANGEBEN' | translate}}
      </div>
    }
  </div>
</div>
<button
  class="soft-button primary rounded w-full mt-auto mb-4 h-16"
  (click)="emitWarenzugangBuchen()"
  [disabled]="((_eingabeLieferscheinnummerPflicht && !lieferscheinnummerValid$.value) ||
              (!form.controls['bezugsdatum'].valid))">
  {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_WARENZUGANG_BUCHEN' | translate}}
</button>
